module.exports = __webpack_public_path__ + "fonts/Inter-600-greek60.eb1153e.woff2";